import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  admins: [],
  loading: false,
  error: null,
  selectedAdmin: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
};

const adminSlice = createSlice({
  name: "Admin",
  initialState,
  reducers: {
    fetchAdminStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAdminSuccess(state, action) {
      state.admins = action.payload.admins;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchAdminFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addAdminStart(state) {
      state.loading = true;
      state.error = null;
    },
    addAdminSuccess(state, action) {
      state.loading = false;
      state.admins.unshift(action.payload);
      state.error = null;
    },
    addAdminFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteAdminStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteAdminSuccess(state, action) {
      state.loading = false;
      state.admins = state.admins.filter(
        (admin) => admin.id !== action.payload
      );
      state.error = null;
    },
    deleteAdminFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    editAdminStart(state) {
      state.loading = true;
      state.error = null;
    },
    editAdminSuccess(state, action) {
      state.loading = false;
      const updatedAdmin = action.payload;
      const index = state.admins.findIndex(
        (admin) => admin.id === updatedAdmin.id
      );
      if (index !== -1) {
        state.admins[index] = updatedAdmin;
      }
      state.error = null;
    },
    editAdminFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    updateAdminStatusStart(state) {
      state.loading = false;
      state.error = null;
    },
    updateAdminStatusSuccess(state, action) {
      state.loading = false;
      const updatedAdmin = action.payload;
      const index = state.admins.findIndex(
        (admin) => admin.id === updatedAdmin.id
      );
      if (index !== -1) {
        state.admins[index] = updatedAdmin;
      }
    },
    updateAdminStatusFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },

    getAdminByIdStart(state) {
      state.loading = false;
      state.error = null;
      state.selectedAdmin = null;
    },
    getAdminByIdSuccess(state, action) {
      state.loading = false;
      state.selectedAdmin = action.payload;
      state.error = null;
    },
    getAdminByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetAdmin(state) {
      state.admins = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  resetAdmin,
  editAdminFailure,
  editAdminSuccess,
  editAdminStart,
  deleteAdminFailure,
  deleteAdminSuccess,
  deleteAdminStart,
  addAdminFailure,
  addAdminSuccess,
  addAdminStart,
  fetchAdminFailure,
  fetchAdminSuccess,
  fetchAdminStart,
  updateAdminStatusFailure,
  updateAdminStatusSuccess,
  updateAdminStatusStart,
  getAdminByIdStart,
  getAdminByIdSuccess,
  getAdminByIdFailure,
} = adminSlice.actions;

export default adminSlice.reducer;
